import { render, staticRenderFns } from "./SocialOverview.vue?vue&type=template&id=88bcbe2e&scoped=true&lang=html&"
import script from "./SocialOverview.vue?vue&type=script&lang=js&"
export * from "./SocialOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bcbe2e",
  null
  
)

export default component.exports